import {
  appInitialized,
  clientAuthenticationSuccess,
  clientAuthenticationError,
  clientDisconnected,
  clientConnected,
  serverError,
} from 'app/modules/app';
import { checkRules, evaluateStage } from 'app/modules/configuration';
import checkAuth from 'app/modules/user/actions/checkAuth';
import sendPendingMessages from 'app/modules/messages/actions/sendPendingMessages';

const REFRESH_CONFIG_INTERVAL = 60000; // 60 seconds in ms

export default class ChatGatewayObserver {
  constructor(context) {
    this.context = context;
  }

  handleError(err) {
    console.log('gateway encountered an error');
    console.log(err);
  }

  handleServerError(err) {
    this.context.executeAction(serverError(err));
  }

  handleConnect() {
    this.context.executeAction(clientConnected());
  }

  handleDisconnect() {
    this.context.executeAction(clientDisconnected());
  }

  handleAuthenticatedSuccess(userObj) {
    this.context.executeAction(appInitialized());
    this.context.executeAction(clientAuthenticationSuccess(userObj));
    this.context.executeAction(checkRules());
    this.context.executeAction(evaluateStage());
    this.context.executeAction(sendPendingMessages());
  }

  handleAlreadyAuthenticated() {
    this.context.executeAction(appInitialized());
    this.context.executeAction(checkRules());
    this.context.executeAction(evaluateStage());
  }

  handleAuthenticatedError(err) {
    this.context.executeAction(appInitialized());
    this.context.executeAction(checkRules());
    this.context.executeAction(evaluateStage());
    this.context.executeAction(clientAuthenticationError(err));
  }

  handleAuthNewUser() {
    this.context.executeAction(appInitialized());
    this.context.executeAction(clientAuthenticationError());
    this.context.executeAction(checkRules());
    this.context.executeAction(evaluateStage());
  }

  handleProviderConfigured() {
    this.context.executeAction(checkAuth());
    window.setInterval(() => this.context.gateways.configurationGateway.refreshConfig(), REFRESH_CONFIG_INTERVAL);
  }
}
